module.exports = __webpack_public_path__ + "img/l3.4be944b9.png";